const rtlLangs = [
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
];
const isRtl = (locale) => !!locale && rtlLangs.includes(locale.split("-|_")[0].toLowerCase());
const getLangDir = (locale) => isRtl(locale) ? "rtl" : "ltr";
export {
  getLangDir
};
//# sourceMappingURL=rtlUtils.js.map
